import React, { createContext, useState, useContext, ReactNode, useEffect } from 'react';
import { useLocation } from '@umijs/max';
interface HotkeysContextType {
  // 模块热键启用状态
  modules: {
    saasDispute: boolean;
    emailTicket: boolean;
    // 可以添加其他模块
  };
  // 更新某个模块的热键状态
  updateModuleState: (module: keyof HotkeysContextType['modules'], enabled: boolean) => void;
  // 全局启用/禁用所有热键
  setGlobalEnabled: (enabled: boolean) => void;
  // 全局热键状态
  globalEnabled: boolean;
}

// 创建上下文
const HotkeysContext = createContext<HotkeysContextType>({
  modules: {
    saasDispute: true,
    emailTicket: true,
  },
  updateModuleState: () => { },
  setGlobalEnabled: () => { },
  globalEnabled: true,
});

// 创建 Provider 组件
interface HotkeysProviderProps {
  children: ReactNode;
}

export const HotkeysProvider: React.FC<HotkeysProviderProps> = ({ children }) => {
  const [modules, setModules] = useState({
    saasDispute: true,
    emailTicket: true,
  });

  const [globalEnabled, setGlobalEnabled] = useState(true);

  const location = useLocation();

  // 更新模块状态的方法
  const updateModuleState = (
    module: keyof HotkeysContextType['modules'],
    enabled: boolean
  ) => {
    setModules(prev => ({
      ...prev,
      [module]: enabled,
    }));
  };
  // 模块变跟方法
  const updateModuleStateByRoute = (route: string) => {
    const isSaasDisputeRoute = route.startsWith('/saas-ticket/detail/');
    const isEmailTicketRoute = route.startsWith('/email-ticket/detail/');
    updateModuleState('saasDispute', isSaasDisputeRoute);
    updateModuleState('emailTicket', isEmailTicketRoute);
  };

  useEffect(() => {
    updateModuleStateByRoute(location.pathname);
  }, [location]);

  const value = {
    modules,
    updateModuleState,
    setGlobalEnabled,
    globalEnabled,
  };

  return (
    <HotkeysContext.Provider value={value}>
      {children}
    </HotkeysContext.Provider>
  );
};

export const useHotkeyContext = () => useContext(HotkeysContext);

export default HotkeysContext;
